import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CartModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export interface UpdateAlternateShipParameter extends ApiParameter {
    alternateShipTo: ShipToModel | null;
}

export interface UpdateAlternateShipModel {
    alternateShipTo: ShipToModel | null;
}

type HandlerType = CustomApiHandler<UpdateAlternateShipParameter, UpdateAlternateShipModel>;

export const DispatchUpadteAlternateShip: HandlerType = props => {
    props.dispatch({
        type: "Custom/updateAlternateShip",
        result: props.parameter,
    });
};

export const chain = [DispatchUpadteAlternateShip];

const updateAlternateShip = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        alternateShipTo: {} as ShipToModel,
    },
    "UpdateAlternateShip",
);
export default updateAlternateShip;
